import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { getCommuniqueById } from '../../../services/communiqueService';
import { updateRequestDecision } from '../../../services/serviceRequestService';
import { Communique } from '../../../types/communique';
import pageStyles from '../../Page.module.css';
import formStyles from '../../../components/forms/Form.module.css';

const CommuniqueDetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [communique, setCommunique] = useState<Communique | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchDetails = async () => {
    if (!id) return;
    setIsLoading(true);
    try {
      const data = await getCommuniqueById(parseInt(id));
      setCommunique(data);
    } catch (error) {
      toast.error('فشل في جلب تفاصيل البلاغ.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, [id]);
  // let reason: string | null;
  const handleDecisionUpdate = async (requestId: number, decision: 'approved' | 'rejected') => {
    let reason = '';
    if (decision === 'rejected') {
      reason = prompt('يرجى إدخال سبب الرفض:') || '';
      if (!reason) {
        toast.error('سبب الرفض مطلوب.');
        return;
      }
    }

    const promise = updateRequestDecision(requestId, decision, reason);
    toast.promise(promise, {
      loading: 'جاري تحديث القرار...',
      success: () => {
        fetchDetails(); // إعادة تحميل البيانات
        return 'تم تحديث القرار بنجاح!';
      },
      error: (err: any) => err.response?.data?.message || 'فشل في تحديث القرار.',
    });
  };

  if (isLoading) {
    return <div className={pageStyles.loading}>جاري تحميل التفاصيل...</div>;
  }

  if (!communique) {
    return <div className={pageStyles.error}>لم يتم العثور على البلاغ.</div>;
  }

  return (
    <div className={pageStyles.pageContainer}>
      <div className={pageStyles.pageHeader}>
        <h1>تفاصيل البلاغ: {communique.communique_number}</h1>
      </div>
      <div className={pageStyles.pageContent}>
        <p><strong>تاريخ الاجتماع:</strong> {new Date(communique.meeting_date).toLocaleDateString('ar-EG')}</p>
        <p><strong>الملخص:</strong> {communique.summary || 'لا يوجد'}</p>
      </div>

      <div className={pageStyles.pageContent}>
        <h2>الطلبات المرتبطة ({communique.serviceRequests?.length || 0})</h2>
        <div className={formStyles.tableContainer}>
          <table className={formStyles.table}>
            <thead>
              <tr>
                <th>رقم الطلب</th>
                <th>مقدم الطلب</th>
                <th>الخدمة</th>
                <th>الحالة الحالية</th>
                <th>إجراءات</th>
              </tr>
            </thead>
            <tbody>
              {communique.serviceRequests?.map(req => (
                <tr key={req.id}>
                  <td>{req.id}</td>
                  <td>{req.user?.name}</td>
                  <td>{req.service?.name}</td>
                  <td>{req.status}</td>
                  <td>
                    {req.status === 'pending_committee' ? (
                      <div className={pageStyles.actionButtons}>
                        <button onClick={() => handleDecisionUpdate(req.id, 'approved')} className={formStyles.successButton}>
                          موافقة
                        </button>
                        <button onClick={() => handleDecisionUpdate(req.id, 'rejected')} className={formStyles.dangerButton}>
                          رفض
                        </button>
                      </div>
                    ) : (
                      <span>{req.status === 'approved' ? 'تمت الموافقة' : `تم الرفض: ${req.rejection_reason}`}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CommuniqueDetailsPage;
